module.exports = __webpack_public_path__ + "img/Search.e4b1970e.svg";